// src/pages/Instagram.js
import React from "react";
import { Link } from "react-router-dom";
import { FiTarget, FiFeather, FiShield } from "react-icons/fi";
import useSEO from "../seo/useSEO";

export default function Instagram() {
  useSEO({
    title:
      "Instagram — Photographe culinaire pour restaurants & chefs | Maxime H",
    description:
      "Vous venez d’Instagram ? Découvrez mon travail culinaire et contactez-moi facilement. Photos de plats, portraits de chefs, reportages et lieux. Devis sous 24h.",
    canonical: `${window.location.origin}/instagram`,
    image: "/images/og-default.jpg",
  });

  return (
    <main className="home-light">
      {/* HERO */}
      <section className="home-hero-light">
        <div className="container">
          <div className="home-hero-grid">
            {/* Image */}
            <div className="home-hero-image">
              <img
                src="/images/accueil.jpg"
                alt="Cuisine gastronomique haut de gamme — Maxime H, photographe culinaire"
                loading="eager"
                decoding="async"
              />
            </div>

            {/* Texte */}
            <div className="home-hero-content">
              <h1 className="home-title-light">
                Vous venez d’Instagram 👋
                <br />
                Photographe culinaire pour restaurants, hôtels, traiteurs & marques
              </h1>

              <p className="home-intro-light">
                Besoin d’images fortes pour votre communication (site, réseaux sociaux, Google, menu, presse) ?
                Je vous accompagne avec une approche soignée, efficace et des livrables immédiatement exploitables.
                <br /><br />
                Basé entre Bruxelles et Tomblaine (Nancy), je me déplace en France, au Luxembourg et en Belgique.
              </p>

              {/* CTA : 1 principal + 1 secondaire */}
              <div className="home-cta-row-light">
                <Link to="/contact" className="btn-primary-light">
                  Demander un devis en 24h
                </Link>
                <Link to="/galerie" className="btn-ghost-light">
                  Voir la galerie
                </Link>
              </div>

              {/* Cartes : cohérence avec ta home */}
              <div className="home-cards-row">
                <div className="home-card-light">
                  <div className="home-card-icon">
                    <FiTarget />
                  </div>
                  <h3>Clair & efficace</h3>
                  <p>
                    On va à l’essentiel : vos besoins, votre timing, vos supports. Je vous propose un plan de shooting simple
                    et rentable.
                  </p>
                </div>

                <div className="home-card-light">
                  <div className="home-card-icon">
                    <FiFeather />
                  </div>
                  <h3>Images qui donnent envie</h3>
                  <p>
                    Lumière maîtrisée, textures, dressages, gestes : des visuels pensés pour attirer, rassurer et convertir.
                  </p>
                </div>

                <div className="home-card-light">
                  <div className="home-card-icon">
                    <FiShield />
                  </div>
                  <h3>Livrables prêts</h3>
                  <p>
                    Fichiers optimisés web & réseaux, et versions HD pour print/presse. Délais respectés, process fluide.
                  </p>
                </div>
              </div>
            </div>
            {/* fin content */}
          </div>
        </div>
      </section>

      {/* SECTION : NEXT STEP (très conversion) */}
      <section className="home-section-light centered">
        <div className="container">
          <div className="home-section-inner-light">
            <h2>La prochaine étape</h2>
            <p>
              Dites-moi simplement votre besoin (plats, équipe, salle, reportage, produits) et votre zone. Je vous réponds
              rapidement avec une proposition claire.
            </p>

            <div className="home-cta-row-light home-cta-center">
              <Link to="/contact" className="btn-primary-light">
                Me contacter
              </Link>
              <Link to="/services" className="btn-ghost-light">
                Voir les prestations
              </Link>
            </div>

            <p className="legal-note" style={{ marginTop: 12 }}>
              Astuce : si vous avez un lien Instagram/Google/Menu à améliorer, envoyez-le : je peux vous conseiller sur les
              images à produire en priorité.
            </p>
          </div>
        </div>
      </section>
    </main>
  );
}